import { StylesConfig } from 'react-select';
import Colors from '@domain/constant/colors';

const multiSelectStyles: StylesConfig<any, true> = {
  control: () => ({
    height: '100%',
  }),
  valueContainer: () => ({
    height: '100%',
  }),
  placeholder: () => ({
    position: 'relative',
  }),
  input: () => ({
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    opacity: 0,
  }),
  groupHeading: (base) => ({
    marginLeft: 16,
    color: Colors.C_GREEN_200,
    fontWeight: 'normal',
    fontSize: '13px',
  }),
  group: () => ({
    position: 'relative',
    ':not(:first-child)': {
      paddingTop: 10,
    },
    ':first-child:after': {
      position: 'absolute',
      content: "''",
      left: 16,
      bottom: 0,
      width: 148,
      height: 1,
      background: Colors.C_COOL_GRAY_50,
    },
  }),
  multiValue: (base) => ({
    ...base,
    display: 'inline-block',
    backgroundColor: Colors.C_WHITE,
  }),
  multiValueRemove: () => ({
    display: 'none',
  }),
  indicatorsContainer: () => ({
    display: 'none',
  }),
  menu: () => ({
    overflow: 'hidden',
    position: 'absolute',
    bottom: -4,
    left: 0,
    minWidth: 182,
    padding: '8px 0',
    border: `1px solid ${Colors.C_COOL_GRAY_50}`,
    borderRadius: 16,
    backgroundColor: Colors.C_WHITE,
    boxShadow: '0px 10px 15px rgba(0, 0, 0, 0.1), 0px 4px 6px rgba(0, 0, 0, 0.05)',
    transform: 'translateY(100%)',
  }),
  menuList: () => ({
    overflowY: 'auto',
    maxHeight: 280,

    '::-webkit-scrollbar': {
      width: 4,
    },

    '::-webkit-scrollbar-thumb': {
      backgroundColor: Colors.C_COOL_GRAY_50,
      borderRadius: 2,
    },

    '::-webkit-scrollbar-track': {
      backgroundColor: 'transparent',
    },

    '::-webkit-scrollbar-button': {
      width: 0,
      height: 0,
    },
  }),
  option: (base: any, state: any) => ({
    display: 'flex',
    alignItems: 'center',
    padding: '10px 20px',
    fontWeight: 'normal',
    fontSize: '15px',
    lineHeight: '20px',
    letterSpacing: '-0.36px',
    color: Colors.C_COOL_GRAY_70,
    cursor: 'pointer',

    ':hover': {
      backgroundColor: Colors.C_COOL_GRAY_30,
    },

    ':before': {
      display: 'block',
      marginRight: 12,
      width: 16,
      height: 16,
      border: `1px solid ${Colors.C_COOL_GRAY_50}`,
      borderRadius: 4,
      backgroundImage: state.isSelected ? `url('/img/components/dropDown/iconCheckboxActive.svg')` : 'none',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: state.isSelected ? '16px' : 'contain',
      content: `''`,
    },
  }),
};

export default multiSelectStyles;
